<template>
  <div v-if="items">
    <b-table
      thead-tr-class="z-0"
      style="min-height: auto"
      :items="items"
      :fields="fields"
      :bordered="true"
    >
      <!-- otaUrl -->
      <template #cell(otaUrl)="data">
        <div v-if="data.item.otaUrl.trim()">
          <div v-for="(link, index) in data.item.otaUrl.split(';')" :key="index">
            <a href="#" @click.prevent="toLink(link)">- Link {{ index + 1 }}</a>
          </div>
        </div>
      </template>
      <template #cell(hotelWebsite)="data">
        <div v-if="data.item.hotelWebsite.trim()">
          <div v-for="(link, index) in data.item.hotelWebsite.split(';')" :key="index">
            <a href="#" @click.prevent="toLink(link)">- Link {{ index + 1 }}</a>
          </div>
        </div>
      </template>
    </b-table>
    <div v-if="warrantyFee">
      <span>Tổng phí bảo hành: {{ totalWarrantyFee | fomatCurrency }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        totalWarrantyFee: null,
      }
    },
    mounted() {
      this.calculateTotalWarrantyFee()
    },
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default() {
          return [
            { key: 'displayName', label: 'Tên', class: 'text-left' },
            { key: 'serialNumber', label: 'Mã serial', class: 'text-left' },
            { key: 'mobileUserStr', label: 'Mobile User', class: 'text-left' },
            {
              key: 'totalPrice',
              label: 'Giá bán',
              class: 'text-right',
              formatter: value => this.$options.filters.fomatCurrency(value),
            },
          ]
        },
      },
      warrantyFee: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      toLink(link) {
        if (link.startsWith('http')) {
          window.open(link, '_blank')
        } else {
          window.open(`https://${link}`, '_blank')
        }
      },
      calculateTotalWarrantyFee() {
        this.totalWarrantyFee = this.items.reduce((total, item) => total + item.price, 0)
      },
    },
  }
</script>

<style scoped></style>
